<template>
  <div>
      <v-layout wrap row justify-start  pa-4>
        <v-flex xs12 px-2>
          <v-card class="elevation-24 text-md-center">
            <v-card-title class="headline white--text primary">
							Data
						</v-card-title>
            <v-card-text>
              <v-layout row wrap>
								<v-flex xs12 md12 pa-1>
									<v-textarea
										label="Copy paste google sheet data here"
										v-model="pastedData"
										solo
									></v-textarea>
              	</v-flex>
								<v-flex xs12 class="text-xs-center">
									{{logger}}
								</v-flex>
								<v-flex xs12>
									<div v-for="(item, k) in pKeys" :key="'item-'+k">{{item}}</div>
								</v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="importItems()" :loading="loading" color="error" dark>
                import cities
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
  </div>
</template>

<script>
import { firebase, db, auth, createFirebase, store } from '@/fb';
import { getRandomInt, randomString, getCDate} from '@/customFunction';
import countriesJSON from '@/countries-ash.json'
import axios from 'axios';
import { productApiUrl } from '@/config/urls';
const headers = {
  'Accept': 'application/json'
}
export default {
  data(){
    return {
			loading: false,
			pastedData:null,
			delimiter:',',
			logger:null,
			pKeys:[],
			countriesFullLoaded:countriesJSON,
			taxrates:null,
			last:null,
			limit:3,
			loops:2
    }
  },
  methods: {
		async senditem(item) {
      return new Promise(async (resolve, rej) => {
        let a = await axios.post(productApiUrl('city-update'), item, {
          headers
        }).then(x => x.data).catch(err => console.log(err))
        resolve(a)
      })
    },
    async importItems() {
      return new Promise(async (res, rej) => {
        this.pKeys = []
        var rows = this.pastedData.trim().split('\n');
        var keys = rows[0].split('\t'); // Assuming tab-delimited data
        var result = [];
        for (var i = 1; i < rows.length; i++) {
            var obj = {};
            var values = rows[i].split('\t'); 
            for (var j = 0; j < keys.length; j++) {
                obj[keys[j]] = values[j];
            }
            result.push(obj);
        }
        console.log(result);
        (async () => {
          for (let i = 0; i < result.length; i++) {
            const item = result[i];
            const r = await this.senditem(item)
            console.log(r)
            this.logger = item.city

            let success = false
            if(r && r.done && r[0]) {
              success = true
            }
            this.pKeys.push(`${item.city} =>> ${success}`)

          }
          this.logger = 'DONE'
        })()
      })
    },
    
  },
  props:{
		superAdmin:{
			required:true
		},
		userName:{
			default:null
		}
  },
  computed:{
    
  },
  async created(){

		
  }
}
</script>

<style>
.tokenField * {
  color:white !important;
}
</style>
